<template>
  <div class="animated fadeIn">

    
    <b-card class="card-accent-info" header="Módulos">
      <b-card-body>

        <b-row>
          <b-col cols="auto" class="mr-auto">
              <b-form-group>
                  <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                  &nbsp;
                  <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                  &nbsp;
                  <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
            </b-form-group>
          </b-col>
          <b-col cols="auto" class="">
            <b-form-group>
              <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
              &nbsp;
              <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo Módulo</span></b-button>
            </b-form-group>
          </b-col>
        </b-row>
            

        <b-row>
          <b-col cols="auto">
            <b-form-group>
                <label for="name">Filtro</label>
                <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
            </b-form-group>
            
          </b-col>

          <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>

          <!--
          <b-col cols="auto" class="mr-auto">
            <b-form-group>
                <label for="name">Filtro</label>
                <b-form-input type="text" id="filter" placeholder="Filtro"></b-form-input>
            </b-form-group>
          </b-col>
        -->
          <b-col cols="auto" class="">
            <b-form-group >
                <label for="perPage">Linhas</label>
                <b-form-select v-model="perPage" id="perPage"
                  :plain="true"
                  :options="[5,10,20,50]">
                </b-form-select>
              </b-form-group>
          </b-col>
          
        </b-row>
      

          <b-table
              :items="filteredItems"
              :fields="fields"
              :select-mode="selectMode"
              responsive="sm"
              ref="selectableTable"
              selectable
              @row-selected="onRowSelected"
              :primary-key="primaryKey"
              :tbody-transition-props="transProps"
              sort-icon-left
              @row-clicked="rowClicked"
              :per-page="perPage"
              :current-page="currentPage"
              :busy="isBusy"
              hover
              striped

              >

              <template #table-busy>
                  <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Carregando...</strong>
                  </div>
              </template>
              
              <!-- Example scoped slot for select state illustrative purposes -->
              <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                  <span aria-hidden="true">&check;</span>
                  <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                  <span class="sr-only">Not selected</span>
                  </template>
              </template>

              <template #cell(show_details)="row">
                  <b-row>
                      <b-col cols="auto" class="mr-auto">
                          <b-form-group>
                          <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                          <b-button size="sm" variant="primary"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-file-pdf-o"></i></b-button>
                          </b-form-group>
                      </b-col>
                  </b-row>
              </template>
              
              <template #row-details="row">
                  <b-card>
                      <b-row v-show="row.item.summary && row.item.summary.length > 0">
                          <b-col class="small">Resumo</b-col>
                      </b-row>
                      <b-row>
                          <b-col class="text-primary">{{ row.item.summary }}</b-col>
                      </b-row>
                      <b-row v-show="row.item.content && row.item.content.length > 0">
                          <b-col class="small">Conteúdo</b-col>
                      </b-row>
                      <b-row>
                          <b-col class="text-primary">{{ row.item.content }}</b-col>
                      </b-row>
                      <b-row>
                          <b-col>{{ row.item.content }}</b-col>
                      </b-row>
                      <b-row>
                          <b-col><i>Publicado em <b>{{ row.item.publishedin }}</b> por <b>{{ row.item.publisher }}</b></i></b-col>
                      </b-row>
                  </b-card>
              </template>
              
              <template v-slot:cell(st)="data">
                  <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" />
              </template>
              
              <template v-slot:cell(ispublic)="data">
                  <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
              </template>
              
          </b-table>
          <nav>
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
          </nav>


      </b-card-body>
   </b-card>


   <b-modal
            v-model="editModal"
            id="edit-modal"
            centered
            hide-footer
            title="Módulo"
            size="lg">

      <b-form @submit.stop.prevent="onSubmit">

      <div class="animated fadeIn">
    
        <b-row>
          <b-col md="12">
            
            <b-form>
              <b-form-group
              description=""
              label="Id"
              label-for="id"
              :label-cols="3"
              :horizontal="true">
              <b-form-input v-model="selectedItem.id" id="id" type="text" readonly></b-form-input>
            </b-form-group>          
            </b-form>
            </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            
            <b-form>
              <b-form-group
              description=""
              label="Módulo"
              label-for="name"
              :label-cols="3"
              :horizontal="true">
              <b-form-input v-model="selectedItem.name" id="name" type="text"></b-form-input>
            </b-form-group>          
            </b-form>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form>
              <b-form-group
              description=""
              label="Descrição"
              label-for="description"
              :label-cols="3"
              :horizontal="true">
              <b-form-textarea
                id="textarea"
                v-model="selectedItem.description"
                placeholder=""
                rows="3"
              ></b-form-textarea>
            </b-form-group>          
            </b-form>
          </b-col>
        </b-row>

        <b-input-group class="mb-4">
            <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
        </b-input-group>
      
        <div slot="footer" class="text-right">
          <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
          <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
          <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Grupo de Acesso</span></b-button>
         
        </div>
              
      </div>
      </b-form>

    </b-modal>

  </div>

</template>

<script>
import Vue from 'vue'
import axios from "axios";

import { Switch as cSwitch } from '@coreui/vue'

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
//import { table } from 'console'

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */

const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}

export default {
  name: 'tables',
  components: {
    Event,
    cSwitch
  },
  data: () => {
    return {

      isBusy: false,
      currentPage: 1,
      switchLabelIcon: {
          dataOn: '\u2713',
          dataOff: '\u2715'
      },
      switchLabelTxt: {
          dataOn: 'yes',
          dataOff: 'no'
      },

      tableRef: "table",
      tableSelectable: false,
      errorMessage: '',
      editModal: false,
      filters: {
        key: ''
      },

      modes: ['multi', 'single', 'range'],
      selectMode: 'multi',
      selected: [],
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      primaryKey: "id",

      selectedItem: newItem,
      items: [        
      ],
      fields: [
        //{key: 'show_details', label: "", thStyle: { width: "100px" } },
        //{key: 'id' },
        {key: 'name', label: 'Grupo de Acesso', sortable: true },
        {key: 'description', label: 'Descrição', sortable: true },
        //{key: 'ispublic', label: 'Público', sortable: true, thStyle: { width: "40px" } },
        {key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
      ],
      
      filterable: ['username'],
      sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
      perPage: 20
    }
  },
  computed: {
    totalRows: function () { return this.getRowCount() },
    filteredItems() {
      try {
          return this.items.filter(item => {
            return this.filters.key == '' || item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1
          })
      }
      catch(e) {
          return this.items;
      }
    }
  },
  methods: {
    getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
    
    save() {
      console.log('Salvando grupo de acesso')
      console.log(this.selectedItem);

      toast ({
          type: VueNotifications.types.warn,
          title: 'Grupo de Acesso',
          message: 'Salvando',
          timeout: 3000
        })
    },
    enableDisable() {
      console.log('Habilitando/desabilitando grupo de acesso')
      console.log(this.selectedItem);
    },
    closeEditModal() {
      this.editModal = false;
    },
    openEditModal(item) {
      if(item == null) {
          this.selectedItem = newItem;      
      }
      else {
          this.selectedItem = JSON.parse(JSON.stringify(item));
      }
      this.editModal = true;
    },
    onRowSelected(items) {
      this.selected = items
      //console.log(items);
      //this.openEditModal(items[0])
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelectedRows() {
      this.$refs.selectableTable.clearSelected();
    },
    rowClicked(item) {
      if(!this.tableSelectable) {
          this.clearSelectedRows();
          this.openEditModal(item);
      }
    },
    getBadge (status) {
      return status === 'A' ? 'primary'
          : status === 'I' ? 'danger'
          : status === 'Pending' ? 'warning'
              : status === 'Banned' ? 'danger' : 'primary'
    },
    toggleBusy() {
      this.isBusy = !this.isBusy
    },
    async refreshData() {
      var s = this;
      var currentUser = this.$store.state.currentUser;


      await axios.get(
          this.$store.state.ws_url + "/group?uid=" + currentUser.id + "&sid=" + currentUser.sid
      ).then(function(resp) {
          s.items = resp.data.obj;
      }).catch(function(error) {
        console.log(error)
      })
      
      this.isBusy = false;
     
    }
  },
  mounted: function() {
    this.isBusy = true;
    this.refreshData();
  }
}
</script>

<style scoped>
table#table-transition-example .flip-list-move {
transition: transform 1s;
}
</style>